module.exports = __webpack_public_path__ + "img/tecnicart.bf9dec01.jpg";